import React from 'react';

import MultiSelect from '../../../../../common/data-entry/MultiSelect/MultiSelect';

import './MultiSelectStudyType.scss';

export const studyTypeOptionsMap = [
  { id: 'ELLIGO_MANAGED', name: 'Elligo Managed' },
  { id: 'FMS', name: 'FMS' },
  { id: 'PATIENT_TRAVEL', name: 'Patient Travel' }
];

export const studyTypeOptions = ['ELLIGO_MANAGED', 'FMS', 'PATIENT_TRAVEL'];

export default function MultiSelectStudyType({
  filteredStudyTypes,
  setFilteredStudyTypes,
  setInitialStudyTypes,
  setIsManualStudyTypeSelection
}) {
  const onChange = newSelections => {
    setFilteredStudyTypes(newSelections.map(opt => opt.id));
    setInitialStudyTypes(newSelections.map(opt => opt.id));
    setIsManualStudyTypeSelection(true);
  };

  return (
    <MultiSelect
      data-testid="study-type-selector"
      controlId="id"
      validate={false}
      clearSearchOnSelection
      label="Study Type"
      groupBy={null}
      optionValueKey="name"
      onChange={onChange}
      className="multi-select-study-type"
      value={filteredStudyTypes.map(id => studyTypeOptionsMap.find(option => option.id === id))}
      dataSource={studyTypeOptionsMap}
    />
  );
}
